var Vendd = (function (Vendd) {
	'use strict';

	Vendd.TrackTrace = (function (TrackTrace) {

	    TrackTrace.Messages = (function (Messages) {
			
	        Messages.GetTrackTraceModel = function (voucherCode, providerId) {
				var data = {
                    voucherCode: voucherCode,
                    providerId: providerId
                };

				Vendd.MessageBus.VenddMessage.call(this, "Vendd.TrackTrace.Messages.GetTrackTraceModel", data);
			}
	        Messages.GetTrackTraceModel.className = "Vendd.TrackTrace.Messages.GetTrackTraceModel";

	        Messages.GetTrackTraceModelSuccess = function (model) {
				var data = {
					model: model
				};
				Vendd.MessageBus.VenddMessage.call(this, "Vendd.TrackTrace.Messages.GetTrackTraceModelSuccess", data);
			}
	        Messages.GetTrackTraceModelSuccess.className = "Vendd.TrackTrace.Messages.GetTrackTraceModelSuccess";

	        Messages.GetTrackTraceModelFailure = function (model) {
				var data = {
					model: model
				};
				Vendd.MessageBus.VenddMessage.call(this, "Vendd.TrackTrace.Messages.GetTrackTraceModelFailure", data);
			}
	        Messages.GetTrackTraceModelFailure.className = "Vendd.TrackTrace.Messages.GetTrackTraceModelFailure";

			
			return Messages;

	    })(TrackTrace.Messages || {});

	    return TrackTrace;

	})(Vendd.TrackTrace || {});

	return Vendd;

})(Vendd || {});
